const DEFAULT_PRODUCTION_API_BASE = 'https://api.salamatlab.com';
const FALLBACK_ORIGIN_BASE_HOSTS = new Set([
    'www.salamatlab.com',
    'salamatlab.com',
    '45.159.150.222',
    '45.159.150.91',
    'localhost',
]);

export const getApiBase = (): string => {
    const configuredBase = import.meta.env.VITE_API_BASE_URL?.trim();
    if (configuredBase) {
        return configuredBase.replace(/\/+$/, '');
    }

    if (!import.meta.env.PROD) {
        return '';
    }

    if (typeof window !== 'undefined') {
        const { origin, hostname } = window.location;
        if (FALLBACK_ORIGIN_BASE_HOSTS.has(hostname)) {
            return origin;
        }
    }

    return DEFAULT_PRODUCTION_API_BASE;
};

export const apiUrl = (path: string): string => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${getApiBase()}${normalizedPath}`;
};
